import { defineComponent as _defineComponent } from 'vue'
import { fetchGetProductionNcSetting } from '@/apis/materialList'
import { getTrialFileRecord, getTrialImageRecord } from '@/apis/paibanHistory'
import { httpRequest } from '@/apis/request'
import { sampleCabinets } from '@/constants'
import { useScroll } from '@/hooks/use-operate-element'
import store from '@/store'
import { translate } from '@/util/commonFun'
import { convertBlobToBase64 } from '@/util/commonFuncs'
import { dealLayoutDataToMaterial } from '@/util/dealPaibanData'
import { promiseToZip } from '@/util/saveFile'
import {
  downloadFile as downloadNCFile,
  mergeFolder,
} from '@/views/newPaiban/util/downLoadNC'
import { Message, Notification } from 'element-ui'
import FileSaver from 'file-saver'
import { reactive, withDefaults } from 'vue'
import { getCurrentInstance } from 'vue'

import { tryProductionColumns } from './config'

interface Props {
  trailProductState: number
}
enum ImgTagEnum {
  guigui = '柜柜',
  web = '云排版',
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    trailProductState: { default: 0 }
  },
  setup(__props: any) {


const { proxy, ctx } = getCurrentInstance() as any
const state = reactive({
  // 显示记录
  isShowRecord: false,
  // 文件表格当前页
  fileListPage: 1,
  // 文件列表总数
  fileListTotal: 0,
  // 是否可以请求文件列表数据
  isRequestFile: true,
  // 图片列表当前页
  imageListPage: 1,
  // 图片列表总数
  imageListTotal: 0,
  // 是否可以请求图片列表数据
  isRequestImage: true,
  // 展示多少页
  limit: 50,
  // 保存文件数据
  fileDataList: [] as any[],
  // 保存图片数据
  imageDataList: [] as any[],
  // 预览图片url
  previewSrcList: [],
  isLoading: false,
})
// 监听表格触底
useScroll('.ant-table-body', '.ant-table-tbody', (v) => {
  if (!v) getListData('file')
})
// 监听图片列表触底
useScroll('.picture-item', '.picture-item-group', (v) => {
  if (!v) getListData('image')
})
// 请求文件/图片列表数据
async function getListData(type: 'image' | 'file') {
  const field = (type.charAt(0).toUpperCase() + type.slice(1)) as
    | 'File'
    | 'Image'
  // 已无法请求则直接返回
  if (!state[`isRequest${field}`]) return
  const params = {
    process_id: 0,
    limit: state.limit,
    page: state[`${type}ListPage`],
  }
  let result
  switch (type) {
    case 'file':
      result = await getTrialFileRecord(params)
      break
    case 'image':
      result = await getTrialImageRecord(params)
  }
  if (result.status !== 1) {
    Message.error({ center: true, message: result.msg ?? '错误!' })
  }
  state[`${type}DataList`] = result.data.data.map(
    (item: any, index: number) => ({
      ...item,
      idx: index,
    })
  )
  state[`${type}ListTotal`] = result.data.total
  // 请求完成一页后增加一页
  if (state[`${type}ListTotal`] / state[`${type}ListPage`] > state.limit) {
    state[`${type}ListPage`] += 1
  } else {
    // 不需要再请求
    state[`isRequest${field}`] = false
  }
}
getListData('file')
getListData('image')
// 下载加工文件
async function handleDownloadFile(record: any) {
  state.isLoading = true
  const { produce_file_url, from } = record
  store.commit('setProduceFileUrl', produce_file_url)
  if (from && from == 'guigui') {
    const ncRes = await fetch(produce_file_url).then((res) => res.blob())
    FileSaver.saveAs(ncRes, `试生产样品柜.zip`)
    state.isLoading = false
    return
  }

  let ncSetting = store.state.ncSetting
  if (record.process_id) {
    const nc_setting_res = await fetchGetProductionNcSetting({
      setting_id: record.process_id,
    })
    if (nc_setting_res.data)
      ncSetting = Object.assign(nc_setting_res.data, {
        process_setting_id: record.process_id,
        process_setting_name: record.process_name,
      })
  }
  store.commit('setNcSetting', ncSetting)
  const nc = await httpRequest.get(produce_file_url)
  const result = await downloadNCFile(
    nc,
    '试生产样品柜',
    [],
    [],
    false,
    '',
    mergeFolder,
    ncSetting
  )
  if (result) {
    const { zip, promises, nameStr } = result
    try {
      for (let index = 0; index < sampleCabinets.length; index++) {
        const file = sampleCabinets[index]
        const result = await fetch(file).then((res) => res.blob())
        const base64Url = await convertBlobToBase64(result)
        zip.file(`试生产样品柜样例图/样品柜样例${index + 1}.png`, base64Url, {
          base64: true,
        })
        if (index === sampleCabinets.length - 1) {
          if (promises) {
            promiseToZip(
              zip,
              promises,
              nameStr,
              (url: string) => [url],
              () => [],
              {},
              store.state.ncSetting
            )
            Notification.success(`${nameStr}下载完成!`)
            state.isLoading = false
          }
        }
      }
    } catch (error) {
      Notification.error(`出现未知错误！`)
      state.isLoading = false
    }
  }
}
/**
 * 是否是外部链接
 * @param path
 */
function isExternal(path: string): boolean {
  return /^(https?|ftp|mailto|tel):/.test(path)
}
/**
 * 通过图片创建时间判断图片是否展示标志（柜柜/云排版）
 * @param {String} t 字符串格式的时间
 * @param {String} origin 来源 柜柜/云排版
 * @return {String} 字符串格式的时间
 * @author zhouchi 2024-08-01
 * */
function handleImgTagbyTime(t: string, origin: 'guigui' | 'web' | ''): string {
  // origin为''表示指定时间（后台决定）的照片不用加前缀
  return origin ? ImgTagEnum[origin] + '  ' + t : t
}
function translateLang(key: string) {
  return translate(key)
}

return { __sfc: true,ImgTagEnum, proxy, ctx, state, getListData, handleDownloadFile, isExternal, handleImgTagbyTime, translateLang, dealLayoutDataToMaterial, tryProductionColumns }
}

})